module.exports = __webpack_public_path__ + "img/jellybean_corvette.f4b474fa.png";